{
  "digital_twin_network": {
    "title": "Não foi possível conectar-se ao Digital Twin",
    "subtitle": "Vamos fazer algumas verificações para ver o que deu errado...",
    "title_success": "Teste de conexão bem-sucedido",
    "subtitle_success": "Para se conectar ao Digital Twin, retorne ao mapa e clique no botão Digital Twin",
    "support_1": " Por favor, revise o ",
    "documentation": "Documentação",
    "support_2": " para configurações de firewall e conexão. Se o problema persistir, entre em contato com o suporte em",
    "iventis_card": {
      "title": "Iventis",
      "subtitle": "Principais serviços de aplicativos"
    },
    "websocket_card": {
      "title": "Websoquete",
      "subtitle": "Estabeleça a conexão Digital Twin"
    },
    "webRTC_card": {
      "title": "WebRTC",
      "subtitle": "Comunicação por vídeo e em tempo real com o Digital Twin"
    },
    "return_to_map": "Retornar ao mapa",
    "recommended_actions": {
      "title": "Ação sugerida",
      "iventis": "Verifique sua conexão com a Internet e tente novamente. Se o problema persistir, entre em contato com o suporte em",
      "websocket": "Verifique suas configurações de rede e firewall para garantir que as conexões Websocket sejam permitidas e que não haja regras de firewall bloqueando a conexão com iventis.com. Se o problema persistir, entre em contato com o suporte em",
      "webRTC": "Verifique suas configurações de rede e firewall para garantir que as conexões WebRTC sejam permitidas e que as portas 19302, 19303 e 10000-65535 estejam abertas e permitam solicitações STUN e TURN para iventis.com. Se o problema persistir, entre em contato com o suporte em"
    },
    "testing": "Testando sua conexão, aguarde..."
  },
  "model_preview": {
    "toggle_bounding_box": "Alternar caixa delimitadora",
    "bounding_box_check": "Verifique se o modelo se encaixa na caixa delimitadora",
    "bounding_box_check_dimensions": "Verifique se o modelo se encaixa na caixa delimitadora e se as dimensões estão corretas",
    "dimensions_warning": "A edição de dimensões não altera o tamanho do modelo. Esses valores são usados como dimensões de referência ao aplicar o dimensionamento personalizado em estilos de camada.",
    "length_axis_colour": "Eixo vermelho",
    "width_axis_colour": "Eixo verde",
    "height_axis_colour": "Eixo azul",
    "advanced_options": "Avançado"
  },
  "data_table_filter": {
    "operator": "Operador"
  },
  "map_settings": {
    "interface_style": "Estilo da interface do mapa",
    "compressed": "Comprimido",
    "spacious": "Espaçoso"
  }
}